import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name calendar-check-2
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNIDE5IDMgTCA1IDMiIC8+CiAgPHBhdGggZD0iTSAyMSAxMyBMIDIxIDUiIC8+CiAgPHBhdGggZD0iTSAyMSA1IEEyIDIgMCAwIDAgMTkgMyIgLz4KICA8cGF0aCBkPSJNIDMgMTkgQTIgMiAwIDAgMCA1IDIxIiAvPgogIDxwYXRoIGQ9Ik0gMyA1IEwgMyAxOSIgLz4KICA8cGF0aCBkPSJNIDUgMyBBMiAyIDAgMCAwIDMgNSIgLz4KICA8cGF0aCBkPSJtMTYgMTkgMiAyIDQtNCIgLz4KICA8cGF0aCBkPSJNMTYgMnYzIiAvPgogIDxwYXRoIGQ9Ik0zIDloMTgiIC8+CiAgPHBhdGggZD0iTTUgMjEgTDEyLjUgMjEiIC8+CiAgPHBhdGggZD0iTTggMnYzIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/calendar-check-2
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const CalendarCheck2: IconNode = [
  ['path', { d: 'M 19 3 L 5 3' }],
  ['path', { d: 'M 21 13 L 21 5' }],
  ['path', { d: 'M 21 5 A2 2 0 0 0 19 3' }],
  ['path', { d: 'M 3 19 A2 2 0 0 0 5 21' }],
  ['path', { d: 'M 3 5 L 3 19' }],
  ['path', { d: 'M 5 3 A2 2 0 0 0 3 5' }],
  ['path', { d: 'm16 19 2 2 4-4' }],
  ['path', { d: 'M16 2v3' }],
  ['path', { d: 'M3 9h18' }],
  ['path', { d: 'M5 21 L12.5 21' }],
  ['path', { d: 'M8 2v3' }],
];

export default CalendarCheck2;
